import { render, staticRenderFns } from "./liabilityTableV2.vue?vue&type=template&id=a6267072"
import script from "./liabilityTableV2.vue?vue&type=script&lang=js"
export * from "./liabilityTableV2.vue?vue&type=script&lang=js"
import style0 from "./liabilityTableV2.vue?vue&type=style&index=0&id=a6267072&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports